import React, { Fragment } from 'react';
import { Row, Col, Typography, Divider, Button } from 'antd';
import {
  CustomButton,
  CustomTable,
  CustomTabs,
  CustomText,
  CustomTextArea,
  FormInput,
  FormSelect,
  UploadWithTable,
} from '../../../../components';
import { UploadedFile } from '../../../../utils';
import { AuthResponse } from '../../../Auth/types';
import { ShareResponse } from '../../../../share';
import { DateTime } from 'luxon';
import { LocationResponse } from '../../../../share/types/location-response';
import {
  FileTextOutlined,
  PlusOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { ColumnsType } from 'antd/es/table';
import { DeleteOutlined } from '@ant-design/icons';
import { AssetsResponse } from '../../../../share/types/asset-response';
import { GoodTypes } from '../../types';

const { Title } = Typography;

interface GoodsCreateViewProps {
  formik: any;
  itemTypes?: ShareResponse[];
  goodConsumos?: any[];
  dependencies?: ShareResponse[];
  authData?: AuthResponse | null;
  onFiles: (files: UploadedFile[]) => void;
  files?: UploadedFile[];
  location?: LocationResponse[];
  //ITEMS
  items?: AssetsResponse[];
  itemsAdded?: AssetsResponse[];
  onAdd?: (item: AssetsResponse) => void;
  onDeleteItem: (item: number) => void;
  setItems?: any;
  //assetList

  //Events
  hanbdleTypeRequest?: (type: number) => void;
}

const GoodsCreateView: React.FC<GoodsCreateViewProps> = ({
  formik,
  itemTypes,
  authData,
  files,
  //goods
  goodConsumos,
  dependencies,
  location,
  items,
  itemsAdded,
  setItems,
  onAdd,
  onDeleteItem,
  onFiles,
  hanbdleTypeRequest,
}) => {
  const [itemAdd, setItemAadd] = React.useState<any>();

  const userPermissions = authData?.portalPermissions || [];
  const isSuperAdmin = !!authData?.superadmin;

  const getFilteredItemTypes = () => {
    if (isSuperAdmin) return itemTypes || [];
    if (userPermissions.includes('webportal-asset-request') && !userPermissions.includes('webportal-goods-request')) {
      return (itemTypes || []).filter(item => Number(item.id) === 1);
    }
    if (!userPermissions.includes('webportal-asset-request') && userPermissions.includes('webportal-goods-request')) {
      return (itemTypes || []).filter(item => Number(item.id) === 2);
    }
    return itemTypes || [];
  };

  const filteredItemTypes = getFilteredItemTypes();

  const columnsActivos: any = [
    {
      title: 'Ítem',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Artículo',
      dataIndex: 'article',
      key: 'article',
      align: 'center',
      render: (data: any) => data ? data : "-"
    },
    {
      title: 'Clase de activos',
      dataIndex: 'asset_class',
      key: 'asset_class',
      align: 'center',
      render: (asset_class: any) =>
        asset_class ? `${asset_class?.code} - ${asset_class.name}` : '-',
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: (a: any, b: any, index: any) => (
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={() => onDeleteItem(index)}
        />
      ),
    },
  ];

  const columnsConsumos: ColumnsType<AssetsResponse> = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Código de producto',
      dataIndex: 'product_code',
      key: 'product_code',
      align: 'center',
      render: (data: any) => data ? data : "-"
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      align: 'center',
      render: (data: any) => data ? data : "-"
    },
    {
      title: 'Grupo de bienes',
      dataIndex: 'good_class',
      key: 'good_class',
      align: 'center',
      render: (data: any) => data ? data.group_code + ' - ' + data.name : "-"
    },
    {
      title: 'Unidad de medida',
      dataIndex: 'unit_measurement',
      key: 'unit_measurement',
      align: 'center',
      render: (data: any) => data ? data.name : "-"
    },
    {
      title: 'Cantidad solicitada',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'center',
      render: (data: any) => data ? data : "-"
    },
    {
      title: 'Acciones',
      key: 'actions',
      render: (_, record, index) => (
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={() => onDeleteItem(index)}
        />
      ),
    },
  ];

  const handleChangeQuantity = (e: React.ChangeEvent<HTMLInputElement>, max: number) => {
    const inputValue = e.target.value;

    if (max && inputValue.length > max) {
      e.target.value = inputValue.slice(0, max);
    }

    return e
  };

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Solicitante"
            name="requester_id"
            placeholder="Solicitante"
            value={`${authData?.user.document} - ${authData?.user.name} ${authData?.user.last_name}`}
            disabled
            error={formik.errors.requester_id}
            touched={formik.touched.requester_id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Fecha de solicitud"
            name="initial_date"
            placeholder="Fecha"
            value={DateTime.now().toFormat('yyyy-MM-dd')}
            disabled
            error={formik.errors.initial_date}
            touched={formik.touched.initial_date}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Dependencia"
            name="dependency_id"
            placeholder="Seleccione la dependencia"
            value={
              formik.values.dependency_id
            }
            options={dependencies}
            error={formik.errors.dependency_id}
            touched={formik.touched.dependency_id}
            onChange={(value) => formik.setFieldValue('dependency_id', value)}
            onBlur={formik.handleBlur}
            disabled
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Ubicación"
            name="location_id"
            placeholder="Seleccione"
            value={formik.values.location_id}
            options={location?.map((x) => {
              return {
                name: x.name + " / " + x.city.name,
                id: x.id.toString(),
              }
            })}
            error={formik.errors.location_id}
            touched={formik.touched.location_id}
            onChange={(value) => formik.setFieldValue('location_id', value)}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        {/* PRUEBA REQUEST TYPE */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <FormSelect
            label="Tipo de solicitud"
            name="goods_type"
            placeholder="Seleccione el tipo de solicitud"
            value={formik.values.goods_type}
            options={filteredItemTypes}
            error={formik.errors.goods_type}
            touched={formik.touched.goods_type}
            onChange={(value) => {
              setItems([]);
              setItemAadd([]);
              hanbdleTypeRequest?.(Number(value));
              formik.setValues({
                ...formik.values,
                goods_type: value,
                item_quantity: '',
                itemable_id: '',
                observations: '',
                asset_class: '',
                articleName: '',
              });
            }}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <FormInput
            label="Estado solicitud"
            name="estadoSolicitud"
            value={`Nuevo`}
            disabled
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <CustomTextArea
            label="Observaciones"
            name="observations"
            placeholder="Seleccione"
            value={formik.values.observations}
            error={formik.errors.observations}
            touched={formik.touched.observations}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      <Divider />

      {formik.values.goods_type === GoodTypes.ACTIVO_FIJO_ID && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <FormSelect
              label="Artículo"
              name="itemable_id"
              placeholder="Seleccione"
              value={formik.values.itemable_id}
              options={items?.map((x: any) => {
                return {
                  name: x.code + " - " + x.name + " / " + 
                    x.asset_class?.code + " - " + x.asset_class?.name + " / " +
                    x.asset_class?.asset_group?.group_type?.type,
                  id: x.id.toString(),
                };
              })}
              error={formik.errors.itemable_id}
              touched={formik.touched.itemable_id}
              onChange={(value) => {
                formik.setFieldValue('itemable_id', value);
                formik.setFieldValue('item_quantity', '1');
                const selectedItem = items?.find(
                  (item) => item.id.toString() === value
                );
                setItemAadd(selectedItem);
              }}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <FormSelect
              label="Clase de activos"
              name="itemable_id"
              placeholder="Seleccione"
              value={formik.values.itemable_id}
              disabled
              options={items?.map((x: any) => {
                return {
                  name: x.asset_class?.code + " - " + (x.asset_class?.name ?? "Sin nombre"),
                  id: x.id.toString(),
                };
              })}
              error={formik.errors.itemable_id}
              touched={formik.touched.itemable_id}
              onChange={(value) => {
                formik.setFieldValue('itemable_id', value);
                formik.setFieldValue('item_quantity', '1');
                const selectedItem = items?.find(
                  (item) => item.id.toString() === value
                );
                setItemAadd(selectedItem);
              }}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <FormInput
              label="Cantidad"
              name="item_quantity"
              placeholder="Inserte"
              type="text"
              value={formik.values.item_quantity}
              error={formik.errors.item_quantity}
              touched={formik.touched.item_quantity}
              onChange={(e) => {
                formik.handleChange(handleChangeQuantity(e, 3));
              }}
              onBlur={formik.handleBlur}
            />

          </Col>
        </Row>
      )}
      {formik.values.goods_type === GoodTypes.BIEN_CONSUMO_ID && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <FormSelect
              label="Bien de consumo"
              name="itemable_id"
              placeholder="Seleccione"
              value={formik.values.itemable_id}
              options={goodConsumos?.map((x) => {
                return {
                  name: x.product_code + " - " + x.description,
                  id: x.id,
                }
              })}
              error={formik.errors.itemable_id}
              touched={formik.touched.itemable_id}
              onChange={(value) => {
                formik.setFieldValue('itemable_id', value);
                const selectedItem = goodConsumos?.find(
                  (item) => item.id === value
                );
                setItemAadd(selectedItem);
              }}
              onBlur={formik.handleBlur}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <FormInput
              label="Grupo de bienes"
              name="asset_class"
              disabled
              value={itemAdd && itemAdd.good_class ? itemAdd.good_class.group_code + ' - ' + itemAdd.good_class.name : ''}
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <FormInput
              label="Cantidad"
              type="number"
              disabled={!itemAdd}
              name="item_quantity"
              placeholder="Seleccione"
              value={formik.values.item_quantity}
              error={formik.errors.item_quantity}
              touched={formik.touched.item_quantity}
              onChange={(e) => {
                formik.handleChange(handleChangeQuantity(e, 3));
              }}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      )}

      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: (
              <Button type="link" icon={<UnorderedListOutlined />}>
                Items
              </Button>
            ),
            children: (
              <Fragment>
                {/* LIST ITEMS */}
                <Row gutter={[16, 16]} justify="end">
                  <Col>
                    <CustomButton
                      onClick={() => {
                        let selectedItem: any = null;

                        if (
                          formik.values.goods_type === GoodTypes.ACTIVO_FIJO_ID
                        ) {
                          selectedItem = items?.find(
                            (item) =>
                              item.id.toString() === formik.values.itemable_id
                          );
                        } else {
                          selectedItem = goodConsumos?.find(
                            (item) => item.id === formik.values.itemable_id
                          );
                        }
                        if (selectedItem && onAdd) {
                          onAdd({
                            ...selectedItem,
                            article: selectedItem?.code + " - " + selectedItem?.name,
                            quantity: formik.values.item_quantity,
                            plate_code:
                              formik.values.goods_type ===
                                GoodTypes.ACTIVO_FIJO_ID
                                ? selectedItem.plate_code
                                : selectedItem?.product_code,
                            good_class: { ...selectedItem?.good_class }
                          });
                          setItemAadd(undefined);
                          formik.setFieldValue('itemable_id', '');
                        }
                      }}
                      icon={<PlusOutlined />}
                      label="Añadir"
                      disabled={
                        !formik.values.itemable_id ||
                        !formik.values.item_quantity
                      }
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]} className="mt-8">
                  {formik.values.goods_type === GoodTypes.ACTIVO_FIJO_ID && (
                    <Col xs={24}>
                      {itemsAdded && itemsAdded.length > 0 ? (
                        <CustomTable<AssetsResponse>
                          dataSource={itemsAdded}
                          columns={columnsActivos}
                          rowKey="uniqueKey"
                          pagination={false}
                          scroll={{ x: "max-content" }}
                        />
                      ) : (
                        <CustomText
                          text="No hay Bien de activos añadidos, por favor agregue uno"
                          strong
                          centered
                          fontSize="small"
                        />
                      )}
                    </Col>
                  )}
                  {formik.values.goods_type === GoodTypes.BIEN_CONSUMO_ID && (
                    <Col xs={24}>
                      {itemsAdded && itemsAdded.length > 0 ? (
                        <CustomTable<AssetsResponse>
                          dataSource={itemsAdded}
                          columns={columnsConsumos}
                          rowKey="id"
                          pagination={false}
                          scroll={{ x: 'max-content' }}
                        />
                      ) : (
                        <CustomText
                          text="No hay Bien de consumo añadidos, por favor agregue uno"
                          strong
                          centered
                          fontSize="small"
                        />
                      )}
                    </Col>
                  )}
                </Row>
              </Fragment>
            ),
          },
          {
            key: '2',
            label: (
              <Button type="link" icon={<FileTextOutlined />}>
                Documentos
              </Button>
            ),
            children: (
              <>
                <Title
                  level={4}
                  style={{ textAlign: 'center', marginBottom: '20px' }}
                >
                  Documentos cargados
                </Title>
                <Row>
                  <Col xs={24}>
                    <UploadWithTable onFilesChange={onFiles} files={files} />
                  </Col>
                </Row>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default GoodsCreateView;
